export default __webpack_public_path__ + "static/media/Db.2f6a2c5f.mp3";